import React from "react";
import {Button, Col, Form, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    actionChangeInputsModalShoppingCard,
    actionChangeSelectableQuestion
} from "../../../../../../redux/actions/modals/modalShoppingCard";
import {
    actionChangeHandelModalAddPGratuity,
    actionChangeInputsModalAddGratuity
} from "../../../../../../redux/actions/modals/modalGratuity/modalGratuity";

const QuestionsBody = () => {
    const dispatch = useDispatch();
    const {questions, orderDescription, selectableQuestion} = useSelector(state => state.modalShoppingCard);
    const {price: gratuity} = useSelector(state => state.modalGratuity);

    const handelChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(actionChangeInputsModalShoppingCard(name, value));
    };
    const handelSelectableQuestion = (question, answerId, answerTitle) => {
        let ItemNewSelectableQuestion = {question, answerId, answerTitle};
        if (question === 'reward' && answerId !== 4) {
            if (gratuity !== '')
            dispatch(actionChangeInputsModalAddGratuity('price', ''));
        }
        if (answerTitle === 'مبلغ دلخواه') {
            dispatch(actionChangeHandelModalAddPGratuity(true));
        } else if(question ==='reward' && answerTitle === 'صفر') {
            dispatch(actionChangeSelectableQuestion({...ItemNewSelectableQuestion,answerTitle:0}));
        }else {
            dispatch(actionChangeSelectableQuestion(ItemNewSelectableQuestion));
        }
    };
    return (
        <React.Fragment>
            <div className={'box-questions-body-modal-shopping-card'}>
                <div className={'box-add-description'}>
                    <Form.Group controlId="add-description">
                        <Form.Label>افزودن توضیحات سفارش</Form.Label>
                        <Form.Control as="textarea" rows="3"
                                      name={'orderDescription'}
                                      value={orderDescription}
                                      onChange={handelChangeInputs}
                                      placeholder={'میتوانید در این قسمت برای شاپر خود توضیحاتی اضافه کنید...'}/>
                    </Form.Group>
                </div>

                <div className={'list-questions-modal-shopping-card'}>
                    <div className={'item-questions-modal-shopping-card'}>
                        <h6>انعام دلخواه (تماما متعلق به خریدار سفارش شما)</h6>
                        <Row>
                            {
                                [
                                    {id: 1, title: 'صفر', default: true, question: 'reward', value: 0},
                                    {id: 2, title: '50000', default: false, question: 'reward', value: 50000},
                                    {id: 3, title: '100000', default: false, question: 'reward', value: 100000},
                                    {
                                        id: 4,
                                        title: 'مبلغ دلخواه',
                                        default: false,
                                        question: 'reward',
                                        value: gratuity !== '' ? gratuity : 0
                                    },
                                ].map(answer => {
                                    let selectItem = answer.default;
                                    for (const key in selectableQuestion) {
                                        if (typeof selectableQuestion[key].question !== 'undefined'
                                            && selectableQuestion[key].question === answer.question) {
                                            selectItem = selectableQuestion[key].answerId === answer.id;
                                        }
                                    }
                                    return (
                                        <Col xs={6} className={'mt-1'} key={answer.id}>
                                            <Button variant="success"
                                                    onClick={() => handelSelectableQuestion(answer.question, answer.id, answer.title)}
                                                    className={`base-btn-green-border ${selectItem ? 'select-btn-answer' : ''}`}
                                                    block>
                                                {(answer.title === 'صفر')
                                                    ? answer.title //اگر صفر بود
                                                    : (answer.title === 'مبلغ دلخواه')
                                                        ? gratuity !== '' ? parseInt(gratuity).toLocaleString() + ' تومان' : answer.title //مبلغ دلخواه
                                                        : parseInt(answer.title).toLocaleString() + ' تومان' // اگر تومان بود
                                                }
                                            </Button>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                    {questions.length > 0 ?
                        questions.map((question) => {
                            return (
                                <div className={'item-questions-modal-shopping-card'} key={question.id}>
                                    <h6>{question.title}</h6>
                                    <Row>
                                        {
                                            question.answers.map(answer => {
                                                let selectItem = parseInt(answer.default) === 1;
                                                for (const key in selectableQuestion) {
                                                    if (typeof selectableQuestion[key].question !== 'undefined'
                                                        && selectableQuestion[key].question === question.title) {
                                                        selectItem = selectableQuestion[key].answerId === answer.id;
                                                    }
                                                }
                                                return (
                                                    <Col xs={6} className={'mt-1'} key={answer.id}>
                                                        <Button variant="success"
                                                                onClick={() => handelSelectableQuestion(question.title, answer.id, answer.title)}
                                                                className={`base-btn-green-border ${selectItem ? 'select-btn-answer' : ''}`}
                                                                block>{answer.title}</Button>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>
                                </div>
                            );
                        })
                        : ''}
                </div>
            </div>
        </React.Fragment>
    );
};

export default React.memo(QuestionsBody);
